/* eslint-disable react/no-danger */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable semi */
/* eslint-disable max-len */
import React from 'react'
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import { ISupportSpinner } from '../../../shared/Ajax'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { ApplicationModel } from '../../../models/ApplicationModel'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import {
  Checkbox,
  Label, MultiLineField, TabHeading, validateFields,
} from '../../../shared/fields'
import {
  ApplicationTiers, getInvalidFileBlobIds, getLastFY, getNextFY,
} from '../../../shared/Utility'
import { Backdrop } from '../../../shared/Backdrop'
import { DashboardFetch } from '../../../controllers/DashboardFetch'
import { HomeFetch } from '../../../controllers/HomeFetch'

import EMDGAccordion from '../../../shared/EMDGAccordion'
import { NumericCheckboxGroupField } from '../../../shared/fields/CheckboxGroup'
import { Option } from '../../../shared/EditableTable/Model'
import { TargetMarketSelectionReasons } from '../../../models/enums/TargetMarketSelectionReasons'
import { MarketEntryPathways } from '../../../models/enums/MarketEntryPathways'
import { EligibleExpenseTable } from './Components/otherTables/EligibleExpense'
import tierActiveValidator from '../../../shared/tierActiveValidator'

export interface EligibleExpensesPageProps {
    history: H.History
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    markets: any[]
    marketRegions: string[]
    preview?: boolean
    financialYears: Option<string>[]
    eligibleExpenseCategories: Option<string>[]
}

export interface EligibleExpensesPageState {
    loading: boolean
    // dialog: boolean UNUSED, REMOVE THIS
    validationForDeclarationCheckboxError: boolean,
    tierSelectionIsValid: boolean // includes RepBody;
    tierErrorMessage: string
}

export class EligibleExpensesPage extends React.Component<EligibleExpensesPageProps, EligibleExpensesPageState> implements ISupportSpinner {
  ajax: ApplicationController
  hiddenForDeclarationCheckboxValidation: Checkbox
  describeExportPromotionalActivities: MultiLineField
  describeFullCostOfExportPromotionalActivities: MultiLineField
  describePlanToUndertakeExportPromotionalActivities: MultiLineField
  describeBusinessGoalsThroughExportPromotionalActivities: MultiLineField
  describeExperienceCapabilityPreparationInExistingMarkets: MultiLineField
  describeExpandingExportPromotionalActivitiesInExistingMarkets: MultiLineField
  describeExperienceCapabilityPreparationInNewMarkets: MultiLineField
  describeExpandingExportPromotionalActivitiesInNewMarkets: MultiLineField
  describeStrategicShiftOfExportPromotionalActivitiesInNewMarkets: MultiLineField
  describeHowProposedActivitiesAreNew: MultiLineField
  describeHowProposedActivitiesBenefitSmeMembers: MultiLineField
  describeHowManySmeMembersSupportNewActivities: MultiLineField
  describeCharacteristicsOfBusinessesSupportedByNewActivities: MultiLineField
  describeCompetitiveAdvantageOfProducts: MultiLineField
  describeHowScaleBusinessToMatchDemands: MultiLineField
  describeHowComplyLawsInTargetMarkets: MultiLineField
  describePotentialLegalOrFinancialRisks: MultiLineField
  describeHowCompeteInTargetExportMarkets: MultiLineField
  targetMarketSelectionReasons: NumericCheckboxGroupField
  specifyOtherTargetMarketSelectionReasons: MultiLineField
  marketEntryPathways: NumericCheckboxGroupField
  specifyOtherMarketEntryPathways: MultiLineField
  declarationHaveAndMatchMinimumGrant: Checkbox
  declarationMatchTotalGrantAmountSought: Checkbox
  declarationMeetMinimumGrantAmountSpending: Checkbox
  declarationIsExpenseEligible: Checkbox
  eligibleExpenseTable: EligibleExpenseTable
  dashboardFetch: DashboardFetch
  homeFetch: HomeFetch

  constructor(props: EligibleExpensesPageProps) {
    super(props)
    this.ajax = new ApplicationController()
    this.dashboardFetch = new DashboardFetch()
    this.homeFetch = new HomeFetch()

    this.state = {
      loading: false,
      // dialog: false, UNUSED, REMOVE THIS
      validationForDeclarationCheckboxError: false,
      tierSelectionIsValid: true, // if you get to this Tab, it must be true (until you re-validate it)
      tierErrorMessage: '',
    }
  }

  componentDidMount() {
    const { onChange } = this.props

    if (this.props.model.isPeakIndustryBody) {
      onChange({ declarationHaveAndMatchMinimumGrant: false, declarationIsExpenseEligible: false })
    }
  }

  componentDidUpdate() {
    const { model } = this.props
    const { validationForDeclarationCheckboxError } = this.state

    if (validationForDeclarationCheckboxError && (
      (model.declarationHaveAndMatchMinimumGrant || model.isPeakIndustryBody)
        && model.declarationMatchTotalGrantAmountSought
        && (model.declarationMeetMinimumGrantAmountSpending || model.isPeakIndustryBody)
        && model.declarationIsExpenseEligible)
    ) this.setState({ validationForDeclarationCheckboxError: false })
  }

  next = () => {
    const { model } = this.props
    const { loading } = this.state

    if (loading) {
      return
    }

    this.setState({
      validationForDeclarationCheckboxError: this.checkBoxIsTicked(),
    }, () => {
      validateFields(
        (res) => {
          if (res) {
            const { history, onChange } = this.props

            const invalidDocuments = getInvalidFileBlobIds(model)
            const updatedModel = { ...JSON.parse(JSON.stringify(model)), invalidDocuments }

            this.ajax.updateApplication(
              this,
              updatedModel,
              (d) => {
                onChange({ ...model, ...d })
                this.setState({ tierSelectionIsValid: false }, async () => {
                  await this.validateTierOnSaveNext()

                  // Only navigate to next page if validation passes
                  if (this.state.tierSelectionIsValid) {
                    history.push(`/reform/${model.applicationID}/products`)
                  }
                })
              },
            )
          }
        },
        this.hiddenForDeclarationCheckboxValidation,
        this.describeExportPromotionalActivities,
        this.describeFullCostOfExportPromotionalActivities,
        this.describePlanToUndertakeExportPromotionalActivities,
        this.describeBusinessGoalsThroughExportPromotionalActivities,
        this.describeExperienceCapabilityPreparationInExistingMarkets,
        this.describeExpandingExportPromotionalActivitiesInExistingMarkets,
        this.describeExperienceCapabilityPreparationInNewMarkets,
        this.describeExpandingExportPromotionalActivitiesInNewMarkets,
        this.describeStrategicShiftOfExportPromotionalActivitiesInNewMarkets,
        this.describeHowProposedActivitiesAreNew,
        this.describeHowProposedActivitiesBenefitSmeMembers,
        this.describeHowManySmeMembersSupportNewActivities,
        this.describeCharacteristicsOfBusinessesSupportedByNewActivities,
        this.describeCompetitiveAdvantageOfProducts,
        this.describeHowScaleBusinessToMatchDemands,
        this.describeHowComplyLawsInTargetMarkets,
        this.describePotentialLegalOrFinancialRisks,
        this.describeHowCompeteInTargetExportMarkets,
        this.targetMarketSelectionReasons,
        this.specifyOtherTargetMarketSelectionReasons,
        this.marketEntryPathways,
        this.specifyOtherMarketEntryPathways,
        this.eligibleExpenseTable,
      )
    })
  }

  validateTierOnSaveNext = async (): Promise<void> => {
    const { model } = this.props
    const selectedTierValue = model.isPeakIndustryBody ? '0' : model.applicationTier // for RepBody, LHS = 0;

    await tierActiveValidator({
      selectedTierValue,
      dashboardFetch: this.dashboardFetch,
      setState: this.setState.bind(this),
    })
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  hasPlanToMarket = (): boolean => !this.props.model.isPeakIndustryBody || (this.props.model.isPeakIndustryBody && (this.props.model.expenseAreExpandingExportPromotion || this.props.model.expenseEligibleExpensesTraining));

  hasPlanToMarketAndAlreadyExporting = (): boolean => (this.props.model.isPeakIndustryBody && this.props.model.expenseAreExpandingExportPromotion)
      || (!this.props.model.isPeakIndustryBody && (this.props.model.applicationTier === ApplicationTiers.Tier2 || this.props.model.applicationTier === ApplicationTiers.Tier3));

  hasPlanToMarketAndNewToMarket = (): boolean => (!this.props.model.isPeakIndustryBody && this.props.model.applicationTier === ApplicationTiers.Tier1);

  checkBoxIsTicked() {
    const { model } = this.props
    return ((!model.declarationHaveAndMatchMinimumGrant && !model.isPeakIndustryBody)
          || !model.declarationMatchTotalGrantAmountSought
          || (!model.declarationMeetMinimumGrantAmountSpending && !model.isPeakIndustryBody)
              || !model.declarationIsExpenseEligible)
  }

  render() {
    const {
      onChange, model, history, preview, eligibleExpenseCategories, financialYears,
      // expenditureCap, NOTUSED REMOVE !
    } = this.props
    const {
      loading, validationForDeclarationCheckboxError, tierErrorMessage,
    } = this.state
    const curDate = new Date();

    let labelDescribeExportPromotionalActivities = '47. ';
    let labelDescribeFullCostOfExportPromotionalActivities = '48. ';
    let labelDescribePlanToUndertakeExportPromotionalActivities = '49. ';
    let labelDescribeBusinessGoalsThroughExportPromotionalActivities = '50. ';
    let labelDescribeExperienceCapabilityPreparationInExistingMarkets = '51. ';
    let labelDescribeExpandingExportPromotionalActivitiesInExistingMarkets = '52. ';
    let labelDescribeExperienceCapabilityPreparationInNewMarkets = '53. ';
    let labelDescribeExpandingExportPromotionalActivitiesInNewMarkets = '54. ';
    let labelDescribeStrategicShiftOfExportPromotionalActivitiesInNewMarkets = '55. ';
    let labelDescribeHowProposedActivitiesAreNew = '56. ';
    let labelDescribeHowProposedActivitiesBenefitSmeMembers = '57. ';
    let labelDescribeHowManySmeMembersSupportNewActivities = '58. ';
    let labelDescribeCharacteristicsOfBusinessesSupportedByNewActivities = '59. ';

    if (this.hasPlanToMarket()) {
      if (model.isPeakIndustryBody) {
        labelDescribeExportPromotionalActivities += 'Describe the export promotional activities that you have undertaken on behalf of your SME members for the past 2 years.';
        labelDescribeFullCostOfExportPromotionalActivities += `What was the value (full cost) of the export promotional activity expenditure that you have undertaken on behalf of your SME members in the previous (${getLastFY(curDate)}) financial year?`;
        labelDescribePlanToUndertakeExportPromotionalActivities += `Describe the export promotional activities that you plan to undertake on behalf of your SME members in ${getNextFY(curDate)} and ${getNextFY(new Date(curDate.getFullYear() + 1, curDate.getMonth(), curDate.getDate()))}.`;
        labelDescribeBusinessGoalsThroughExportPromotionalActivities += 'Describe the business goals you seek to achieve for your SME members through your export promotional activities and how you will measure export success?';

        labelDescribeHowProposedActivitiesAreNew += 'Describe how the proposed promotional activities are new, compared to activities that have already been supported by EMDG.';
        labelDescribeHowProposedActivitiesBenefitSmeMembers += 'Describe how the proposed new promotional activities will specifically benefit your SME members and align with your SME members’ needs.';
        labelDescribeHowManySmeMembersSupportNewActivities += 'How many SME members are you expecting to support with your new export promotional activities?';
        labelDescribeCharacteristicsOfBusinessesSupportedByNewActivities += 'Describe the characteristics, types and sizes of businesses that will be supported by your new export promotional activities.';
      } else {
        labelDescribeExportPromotionalActivities += 'Describe the export promotional activities that you have undertaken for the past 2 years.';
        labelDescribeFullCostOfExportPromotionalActivities += `What was the value (full cost) of the export promotional activity expenditure on eligible products in the previous (${getLastFY(curDate)}) financial year?`;
        labelDescribePlanToUndertakeExportPromotionalActivities += `Describe the export promotional activities that you plan to undertake to promote your eligible products in ${getNextFY(curDate)} and ${getNextFY(new Date(curDate.getFullYear() + 1, curDate.getMonth(), curDate.getDate()))}.`;
        labelDescribeBusinessGoalsThroughExportPromotionalActivities += 'Describe the business goals you seek to achieve through your export promotional activities and how will you measure your export success?';

        labelDescribeExperienceCapabilityPreparationInExistingMarkets += 'Describe your experience, capability and preparation to expand in your existing export market(s).';
        labelDescribeExpandingExportPromotionalActivitiesInExistingMarkets += 'Describe how you are expanding your export promotional activities within your existing market(s)?';
        labelDescribeExperienceCapabilityPreparationInNewMarkets += 'Describe your experience, capability and preparation to diversify into a new export market(s).';
        labelDescribeExpandingExportPromotionalActivitiesInNewMarkets += 'Describe how you will expand your existing export promotional activities to new \'key\' market(s).';
        labelDescribeStrategicShiftOfExportPromotionalActivitiesInNewMarkets += 'Describe how you will make a strategic shift in your export promotional activities to new \'key\' markets?';
      }
    }

    const targetMarketSelectionOptions:Option<number>[] = model.isPeakIndustryBody
      ? [
        { value: TargetMarketSelectionReasons.RepBodyReceivedEnquiries, label: 'Members have received enquiries from potential customers' },
        { value: TargetMarketSelectionReasons.RepBodyMarketPresentsGoodProspects, label: 'The market presents good prospects for our members’ products' },
        { value: TargetMarketSelectionReasons.RepBodyLookingForOpportunitiesInNewMarkets, label: 'Looking for opportunities to expand into new markets' },
        { value: TargetMarketSelectionReasons.RepBodySuccessfullyExportedToSimilarMarkets, label: 'Members have successfully exported to similar or neighbouring markets' },
        { value: TargetMarketSelectionReasons.RepBodyPursuingTendersInTargetMarkets, label: 'Members are pursuing tenders or contracts in the target markets' },
        { value: TargetMarketSelectionReasons.RepBodyExploringOpporunitiesInFTAMarkets, label: 'Members are exploring opportunities in Free Trade Agreement (FTA) markets' },
        { value: TargetMarketSelectionReasons.RepBodyParticipatingInTradePromtionPrograms, label: 'Members are participating in trade promotion programs targeting the specified markets' },
        { value: TargetMarketSelectionReasons.RepBodyChangesInRegulatoryRequirements, label: 'Changes in the regulatory environment in the market has created potential opportunities for our members products/services' },
        { value: TargetMarketSelectionReasons.RepBodyOtherReasons, label: 'Other reasons, please specify' },
      ]
      : [
        { value: TargetMarketSelectionReasons.TierReceivedEnquiries, label: 'We have received enquiries from potential customers' },
        { value: TargetMarketSelectionReasons.TierMarketPresentsGoodProspects, label: 'The market presents good prospects for our eligible products' },
        { value: TargetMarketSelectionReasons.TierLookingForOpportunitiesInNewMarkets, label: 'Looking for opportunities to expand into new markets' },
        { value: TargetMarketSelectionReasons.TierSuccessfullyExportedToSimilarMarkets, label: 'We have successfully exported to similar or neighbouring markets' },
        { value: TargetMarketSelectionReasons.TierPursuingTendersInTargetMarkets, label: 'We are pursuing tenders or contracts in the target markets' },
        { value: TargetMarketSelectionReasons.TierExploringOpporunitiesInFTAMarkets, label: 'We are exploring opportunities in Free Trade Agreement (FTA) markets' },
        { value: TargetMarketSelectionReasons.TierParticipatingInTradePromtionPrograms, label: 'We are participating in trade promotion programs targeting the specific markets' },
        { value: TargetMarketSelectionReasons.TierChangesInRegulatoryRequirements, label: 'Changes in the regulatory environment in the market has created potential opportunities for our eligible products' },
        { value: TargetMarketSelectionReasons.TierOtherReasons, label: 'Other reasons, please specify' },
      ];

    const marketEntryPathwayOptions:Option<number>[] = [
      { value: MarketEntryPathways.DirectExportToBusiness, label: 'Direct export to business/consumer' },
      { value: MarketEntryPathways.ExportViaDistributor, label: 'Export via distributor' },
      { value: MarketEntryPathways.AttractingVisitors, label: 'Attracting visitors to Australia' },
      { value: MarketEntryPathways.ExportViaOnline, label: 'Export via online channel' },
      { value: MarketEntryPathways.Franchising, label: 'Franchising' },
      { value: MarketEntryPathways.Licensing, label: 'Licensing' },
      { value: MarketEntryPathways.SupportingAustralianBusinesses, label: 'Supporting Australian businesses to grow their exports' },
      { value: MarketEntryPathways.Others, label: 'Other, please specify' },
    ];

    return (
      <>
        <TabHeading
          label="Plan to market and eligible expenses"
          preview={preview}
        />
        {this.hasPlanToMarket() && (
          <div className="form-item">
            { preview && <h3>Plan to market</h3>}
            <EMDGAccordion expanded header="Plan to market">
              {model.isPeakIndustryBody ? (
                <Alert className="emdg-page-alerts">
                  Applicants are required to market eligible products. Representative bodies planning to undertake new export marketing and promotional activities on behalf of their SME members,
                  {' '}
                  <b>must</b>
                  {' '}
                  complete the plan to market questions. If you do not complete the plan to market questions, you are not eligible to apply for a grant.
                  <br />
                  <br />
                  If you are a Representative body
                  {' '}
                  <b>only</b>
                  {' '}
                  providing export training to your SME members to help them become export ready you must upload an export training plan (you must use the export plan template available at
                  {' '}
                  <a target="blank" href="https://www.austrade.gov.au/emdg">www.austrade.gov.au/EMDG</a>
                  ) and are
                  {' '}
                  <b>not</b>
                  {' '}
                  required to respond to the plan to market questions, however you must complete the eligible expenses section.
                  <br />
                  <br />
                  Your plan to market must be unique, high-quality and specific to your business. It must directly relate to your planned export promotional activities. To be considered high-quality, all mandatory questions must be completed with sufficient detail. Austrade will use the plan to market to determine your suitability for the tier you have applied for.
                  <br />
                  <br />
                  You cannot submit plan to market responses that are copied from another business or submit generic marketing plan responses. If you do, your application will be deemed ineligible.
                </Alert>
              )
                : (
                  <Alert className="emdg-page-alerts">
                    Applicants are required to market eligible products. Applicants for Tiers 1, 2 and 3 planning to undertake new export marketing and promotional activities,
                    {' '}
                    <b>must</b>
                    {' '}
                    complete the plan to market questions. If you do not complete the plan to market questions, you are not eligible to apply for a grant.
                    <br />
                    <br />
                    Your plan to market must be unique, high-quality and specific to your business. It must directly relate to your planned export promotional activities. To be considered high-quality, all mandatory questions must be completed with sufficient detail. Austrade will use the plan to market to determine your suitability for the tier you have applied for.
                    <br />
                    <br />
                    You cannot submit plan to market responses that are copied from another business or submit generic marketing plan responses. If you do, your application will be deemed ineligible.
                  </Alert>
                )}

              {this.hasPlanToMarketAndAlreadyExporting() && (
              <>
                <MultiLineField
                  ref={(r) => { this.describeExportPromotionalActivities = r }}
                  id="describeExportPromotionalActivities"
                  label={labelDescribeExportPromotionalActivities}
                  value={model.describeExportPromotionalActivities}
                  onChange={(value) => onChange({ describeExportPromotionalActivities: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting()}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeFullCostOfExportPromotionalActivities = r }}
                  id="describeFullCostOfExportPromotionalActivities"
                  label={labelDescribeFullCostOfExportPromotionalActivities}
                  value={model.describeFullCostOfExportPromotionalActivities}
                  onChange={(value) => onChange({ describeFullCostOfExportPromotionalActivities: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting()}
                  maxLength={3000}
                  preview={preview}
                />
              </>
              )}

              {(this.hasPlanToMarketAndAlreadyExporting() || this.hasPlanToMarketAndNewToMarket()) && (
                <>
                  <MultiLineField
                    ref={(r) => { this.describePlanToUndertakeExportPromotionalActivities = r }}
                    id="describePlanToUndertakeExportPromotionalActivities"
                    label={labelDescribePlanToUndertakeExportPromotionalActivities}
                    value={model.describePlanToUndertakeExportPromotionalActivities}
                    onChange={(value) => onChange({ describePlanToUndertakeExportPromotionalActivities: value })}
                    required={this.hasPlanToMarketAndAlreadyExporting() || this.hasPlanToMarketAndNewToMarket()}
                    maxLength={3000}
                    preview={preview}
                    description={<i>The response to this question needs to align with the below planned expenditure table.</i>}
                  />
                  <MultiLineField
                    ref={(r) => { this.describeBusinessGoalsThroughExportPromotionalActivities = r }}
                    id="describeBusinessGoalsThroughExportPromotionalActivities"
                    label={labelDescribeBusinessGoalsThroughExportPromotionalActivities}
                    value={model.describeBusinessGoalsThroughExportPromotionalActivities}
                    onChange={(value) => onChange({ describeBusinessGoalsThroughExportPromotionalActivities: value })}
                    required={this.hasPlanToMarketAndAlreadyExporting() || this.hasPlanToMarketAndNewToMarket()}
                    maxLength={3000}
                    preview={preview}
                    description={<i>(For example, increase export sales by 10%, increase the volume and yield from visitors by 15%, appoint a partner or distributor, be shortlisted for a potential contract or tender.)</i>}
                  />
                </>
              )}

              {this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier2 && (
              <>
                <MultiLineField
                  ref={(r) => { this.describeExperienceCapabilityPreparationInExistingMarkets = r }}
                  id="describeExperienceCapabilityPreparationInExistingMarkets"
                  label={labelDescribeExperienceCapabilityPreparationInExistingMarkets}
                  value={model.describeExperienceCapabilityPreparationInExistingMarkets}
                  onChange={(value) => onChange({ describeExperienceCapabilityPreparationInExistingMarkets: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier2}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeExpandingExportPromotionalActivitiesInExistingMarkets = r }}
                  id="describeExpandingExportPromotionalActivitiesInExistingMarkets"
                  label={labelDescribeExpandingExportPromotionalActivitiesInExistingMarkets}
                  value={model.describeExpandingExportPromotionalActivitiesInExistingMarkets}
                  onChange={(value) => onChange({ describeExpandingExportPromotionalActivitiesInExistingMarkets: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier2}
                  maxLength={3000}
                  preview={preview}
                />
              </>
              )}

              {this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier3 && (
              <>
                <MultiLineField
                  ref={(r) => { this.describeExperienceCapabilityPreparationInNewMarkets = r }}
                  id="describeExperienceCapabilityPreparationInNewMarkets"
                  label={labelDescribeExperienceCapabilityPreparationInNewMarkets}
                  value={model.describeExperienceCapabilityPreparationInNewMarkets}
                  onChange={(value) => onChange({ describeExperienceCapabilityPreparationInNewMarkets: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier3}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeExpandingExportPromotionalActivitiesInNewMarkets = r }}
                  id="describeExpandingExportPromotionalActivitiesInNewMarkets"
                  label={labelDescribeExpandingExportPromotionalActivitiesInNewMarkets}
                  value={model.describeExpandingExportPromotionalActivitiesInNewMarkets}
                  onChange={(value) => onChange({ describeExpandingExportPromotionalActivitiesInNewMarkets: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier3}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeStrategicShiftOfExportPromotionalActivitiesInNewMarkets = r }}
                  id="describeStrategicShiftOfExportPromotionalActivitiesInNewMarkets"
                  label={labelDescribeStrategicShiftOfExportPromotionalActivitiesInNewMarkets}
                  value={model.describeStrategicShiftOfExportPromotionalActivitiesInNewMarkets}
                  onChange={(value) => onChange({ describeStrategicShiftOfExportPromotionalActivitiesInNewMarkets: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && !model.isPeakIndustryBody && model.applicationTier === ApplicationTiers.Tier3}
                  maxLength={3000}
                  preview={preview}
                />
              </>
              )}

              {this.hasPlanToMarketAndAlreadyExporting() && model.isPeakIndustryBody && (
              <>
                <MultiLineField
                  ref={(r) => { this.describeHowProposedActivitiesAreNew = r }}
                  id="describeHowProposedActivitiesAreNew"
                  label={labelDescribeHowProposedActivitiesAreNew}
                  value={model.describeHowProposedActivitiesAreNew}
                  onChange={(value) => onChange({ describeHowProposedActivitiesAreNew: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && model.isPeakIndustryBody}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeHowProposedActivitiesBenefitSmeMembers = r }}
                  id="describeHowProposedActivitiesBenefitSmeMembers"
                  label={labelDescribeHowProposedActivitiesBenefitSmeMembers}
                  value={model.describeHowProposedActivitiesBenefitSmeMembers}
                  onChange={(value) => onChange({ describeHowProposedActivitiesBenefitSmeMembers: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && model.isPeakIndustryBody}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeHowManySmeMembersSupportNewActivities = r }}
                  id="describeHowManySmeMembersSupportNewActivities"
                  label={labelDescribeHowManySmeMembersSupportNewActivities}
                  value={model.describeHowManySmeMembersSupportNewActivities}
                  onChange={(value) => onChange({ describeHowManySmeMembersSupportNewActivities: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && model.isPeakIndustryBody}
                  maxLength={3000}
                  preview={preview}
                />
                <MultiLineField
                  ref={(r) => { this.describeCharacteristicsOfBusinessesSupportedByNewActivities = r }}
                  id="describeCharacteristicsOfBusinessesSupportedByNewActivities"
                  label={labelDescribeCharacteristicsOfBusinessesSupportedByNewActivities}
                  value={model.describeCharacteristicsOfBusinessesSupportedByNewActivities}
                  onChange={(value) => onChange({ describeCharacteristicsOfBusinessesSupportedByNewActivities: value })}
                  required={this.hasPlanToMarketAndAlreadyExporting() && model.isPeakIndustryBody}
                  maxLength={3000}
                  preview={preview}
                />
              </>
              )}
            </EMDGAccordion>
          </div>
        )}
        <div className="form-item">
          { preview && <h3>Eligible expenses</h3>}
          <EMDGAccordion expanded header="Eligible expenses">
            <Label
              label={`60. Complete the table to show your planned eligible promotional (and/or export training activities for Tier 1 and Representative body) activities and associated eligible expenditure that you intend to undertake in ${financialYears.length > 0 ? financialYears.at(0).label : null} ${financialYears.length > 1 ? `and ${financialYears.at(1).label}` : null}. *`}
              preview={preview}
            />
            <Alert className="emdg-page-alerts">
              <ul>
                {!model.isPeakIndustryBody ? (
                  <>
                    <li> Your total minimum planned eligible expenditure cannot be less than $40,000 per financial year.</li>
                    <li> You must upload a copy of your most recent bank statement issued in 2024 and your bank account transaction history for the month of November 2024 to demonstrate that you have available funds and are able to spend at least $20,000 on your proposed marketing and promotional activities per financial year. You will need to upload up to 2 documents, i.e. your most recent bank statement in 2024, and an up-to-date bank account transaction report for the month of November 2024.</li>
                  </>
                ) : null}
                <li>The minimum capacity to spend and the minimum grant thresholds do not apply to Representative Body applicants.</li>
                <li>
                  The maximum grant amounts per grant tier are:
                  <ul>
                    <li>Tier 1 – Up to $30,000 per financial year</li>
                    <li>Tier 2 – Up to $50,000 per financial year</li>
                    <li>Tier 3 – Up to $80,000 per financial year</li>
                    <li>Representative bodies – Up to $50,000 per financial year</li>
                  </ul>
                </li>
                <li>Your Total Planned Eligible Expenditure will be automatically calculated in the table as the sum of the amounts you entered for each planned eligible expenditure category.</li>
                <li>Your Total Planned Eligible Expenditure cannot be more than double the maximum grant amount for the relevant tier. Refer to section 5.3 of the Grant Guidelines for guidance on eligible expenditure.</li>
                <li>Your Total Grant Amount Sought per financial year is calculated as 50% of your planned eligible expenditure up to the maximum grant amount per tier. You can only receive a grant for eligible expenditure.</li>
                <li>You must match the Total Grant Amount Sought with your own funds.</li>
                <li>Please double check your Total Grant Amount Sought and ensure that you can match the grant with your own funds.</li>
                <li>Your Total Grant Amount Sought cannot be less than $20,000 per financial year for Tiers 1, 2 and 3.</li>
                {!model.isPeakIndustryBody ? (
                  <>
                    <li>If you end up spending less than $20,000 per financial year on your eligible marketing and promotional activities, you will not receive a grant payment and you may be asked to repay the grant for the relevant financial year if you already received it.</li>
                    <li>If you only apply for one year grant funding, select the financial year that you would like to receive funding for and input your planned expenditure category and amounts accordingly. For the financial year that you do not want to receive funding input $0. </li>
                  </>
                ) : null}

              </ul>
            </Alert>
            <EligibleExpenseTable ref={(r) => { this.eligibleExpenseTable = r }} model={model} onChange={onChange} tierNo={parseInt(model.applicationTier, 10)} financialYears={financialYears} eligibleExpenseCategories={eligibleExpenseCategories} />
            <h4>Declaration on planned eligible expenditure</h4>
            <Checkbox
              ref={(r) => { this.hiddenForDeclarationCheckboxValidation = r }}
              id="hiddenForDeclarationCheckboxValidation"
              required={this.checkBoxIsTicked()}
              onChange={() => { }}
              value={false}
              label=""
              className="hidden-checkbox"
            />
            {validationForDeclarationCheckboxError ? (<div className="form-error" style={{ marginBottom: '8px' }}>This field is required</div>) : null}
            {!model.isPeakIndustryBody && (
            <Checkbox
              ref={(r) => { this.declarationHaveAndMatchMinimumGrant = r }}
              id="declarationHaveAndMatchMinimumGrant"
              required={!model.isPeakIndustryBody}
              onChange={(val) => onChange({ declarationHaveAndMatchMinimumGrant: val || null })}
              value={model.declarationHaveAndMatchMinimumGrant}
              label="I declare that I have the minimum $20,000 per financial year to match the minimum grant of $20,000 per financial year."
              preview={preview}
              validateError={validationForDeclarationCheckboxError}
            />
            )}
            <Checkbox
              ref={(r) => { this.declarationMatchTotalGrantAmountSought = r }}
              id="declarationMatchTotalGrantAmountSought"
              required
              onChange={(val) => onChange({ declarationMatchTotalGrantAmountSought: val || null })}
              value={model.declarationMatchTotalGrantAmountSought}
              label="I declare that I can match the Total grant amount sought and can provide further information to substantiate the budgeted planned expenditure per financial year."
              preview={preview}
              validateError={validationForDeclarationCheckboxError}
            />
            {!model.isPeakIndustryBody && (
            <Checkbox
              ref={(r) => { this.declarationMeetMinimumGrantAmountSpending = r }}
              id="declarationMeetMinimumGrantAmountSpending"
              required={!model.isPeakIndustryBody}
              onChange={(val) => onChange({ declarationMeetMinimumGrantAmountSpending: val || null })}
              value={model.declarationMeetMinimumGrantAmountSpending}
              label="I declare and understand that if I spend less than $20,000 per financial year on eligible promotional activities, I will not receive a grant payment. I may be asked to repay the grant for the relevant financial year if I already received it."
              preview={preview}
              validateError={validationForDeclarationCheckboxError}
            />
            )}

            <Checkbox
              ref={(r) => { this.declarationIsExpenseEligible = r }}
              id="declarationIsExpenseEligible"
              required
              onChange={(val) => onChange({ declarationIsExpenseEligible: val || null })}
              value={model.declarationIsExpenseEligible}
              label="I declare that I do not intend to seek grant funding for ineligible expenses. Ineligible expenses include those that are:"
              preview={preview}
              description={(
                <ul>
                  <li>covered by other financial assistance schemes and grant programs</li>
                  <li>
                    related to a product where the sale or export of products contravenes Australian law.
                    This includes all sanctions under the Charter of the United Nations Act 1945 and its regulations, the Autonomous Sanctions Act 2011 and the Autonomous Sanctions Regulations 2011.
                    Information on Australia’s sanctions can be found at:
                    {' '}
                    <a href="https://www.dfat.gov.au/international-relations/security/sanctions" target="_blank" rel="noreferrer">dfat.gov.au/international-relations/security/sanctions/Pages/sanctions</a>
                  </li>
                  <li>for the purpose of soliciting sponsorship for an event</li>
                  <li>capital in nature unless they are related to grant, registration or extension of rights for an intellectual property</li>
                  <li>related to trade with New Zealand</li>
                  <li>paid or are entitled to be paid</li>
                  <li>incurred in payment of an Australian law, levy or charge (except Australian departure tax)</li>
                  <li>sales related, e.g. a commission, a discount or credit for sales of an eligible product or salaries, retainers or fee paid by reference to sales or other commercial transactions</li>
                  <li>a normal part of remuneration (including payment to individuals normally employed by the grantee, or a related entity of the grantee; a company director; a partner; or a trustee)</li>
                  <li>related to an illegal or unlawful activity</li>
                  <li>likely to have a detrimental impact on Australia’s trade reputation</li>
                  <li>related to engaging a grant agent or a third party to assist you with completing an application and/or manage your reporting obligations during the life of the grant agreement</li>
                  <li>made by representative bodies if incurred for a member of the representative body that is an EMDG grantee at the time.</li>
                </ul>
              )}
              validateError={validationForDeclarationCheckboxError}
            />

          </EMDGAccordion>
        </div>
        <div className="form-item">
          { preview && <h3>Optional questions</h3>}
          <EMDGAccordion expanded header="Optional questions">
            <Alert className="emdg-page-alerts">
              Your responses to the following questions are optional. Answering these questions will help Austrade understand your business’ overall export readiness as outlined in
              {' '}
              <a target="blank" href="https://export.business.gov.au/">Austrade’s Go Global toolkit.</a>
              {' '}
              The toolkit is designed to assist businesses to strengthen their export capabilities. Based on your answers, Austrade may contact you to offer additional trade support services to your business.
            </Alert>
            <MultiLineField
              ref={(r) => { this.describeCompetitiveAdvantageOfProducts = r }}
              id="describeCompetitiveAdvantageOfProducts"
              label={
                model.isPeakIndustryBody
                  ? (
                    <span>
                      61. Describe the competitive advantage or
                      {' '}
                      <a target="blank" href="https://export.business.gov.au/get-started-with-exporting/develop-your-unique-selling-proposition">unique selling proposition</a>
                      {' '}
                      your SME members have in export markets.
                    </span>
                  )
                  : (
                    <span>
                      61. Describe the competitive advantage or
                      {' '}
                      <a target="blank" href="https://export.business.gov.au/get-started-with-exporting/develop-your-unique-selling-proposition">unique selling proposition</a>
                      {' '}
                      of your products.
                    </span>
                  )
}
              value={model.describeCompetitiveAdvantageOfProducts}
              onChange={(value) => onChange({ describeCompetitiveAdvantageOfProducts: value })}
              maxLength={3000}
              preview={preview}
            />
            <MultiLineField
              ref={(r) => { this.describeHowScaleBusinessToMatchDemands = r }}
              id="describeHowScaleBusinessToMatchDemands"
              label={model.isPeakIndustryBody ? (
                <span>
                  62. How will the businesses you represent scale up (including
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/pricing-costs-and-finance">financial resources</a>
                  ) to match increased demand for their eligible products?
                </span>
              ) : (
                <span>
                  62. How will you scale up your business (including
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/pricing-costs-and-finance">financial resources</a>
                  ) to match increased demand for your eligible product?
                </span>
              )}
              value={model.describeHowScaleBusinessToMatchDemands}
              onChange={(value) => onChange({ describeHowScaleBusinessToMatchDemands: value })}
              maxLength={3000}
              preview={preview}
            />
            {!model.isPeakIndustryBody && (
            <MultiLineField
              ref={(r) => { this.describeHowComplyLawsInTargetMarkets = r }}
              id="describeHowComplyLawsInTargetMarkets"
              label={(
                <span>
                  63. How will you comply with
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/laws-and-regulations">laws or regulations</a>
                  {' '}
                  that are relevant to your eligible product in your target markets?
                </span>
              )}
              value={model.describeHowComplyLawsInTargetMarkets}
              onChange={(value) => onChange({ describeHowComplyLawsInTargetMarkets: value })}
              maxLength={3000}
              preview={preview}
            />
            )}
            <MultiLineField
              ref={(r) => { this.describePotentialLegalOrFinancialRisks = r }}
              id="describePotentialLegalOrFinancialRisks"
              label={model.isPeakIndustryBody ? (
                <span>
                  64. What potential legal or financial
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/get-started-with-exporting/export-benefits-and-risks">risks</a>
                  {' '}
                  will your SME members need to manage in their export activities (e.g. ensuring they get paid, protecting their intellectual property, disruptions to their supply chain, handling unanticipated changes in market demand, managing currency fluctuations etc.) and how do you plan to mitigate them?
                </span>
              )
                : (
                  <span>
                    64. What potential legal or financial
                    {' '}
                    <a target="blank" href="https://export.business.gov.au/get-started-with-exporting/export-benefits-and-risks">risks</a>
                    {' '}
                    will you need to manage in your export activities (e.g. ensuring you get paid, protecting your intellectual property, disruptions to your supply chain, handling unanticipated changes in market demand, managing currency fluctuations etc.) and how do you plan to mitigate them?
                  </span>
                )}
              value={model.describePotentialLegalOrFinancialRisks}
              onChange={(value) => onChange({ describePotentialLegalOrFinancialRisks: value })}
              maxLength={3000}
              preview={preview}
            />

            <NumericCheckboxGroupField
              id="targetMarketSelectionReasons"
              ref={(r) => { this.targetMarketSelectionReasons = r }}
              label={(
                <span>
                  65. Why did you
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/find-export-markets">select your target</a>
                  {' '}
                  export markets? (choose all that apply)
                </span>
            )}
              dataSource={targetMarketSelectionOptions}
              value={model.targetMarketSelectionReasons}
              onChange={(value) => onChange({ targetMarketSelectionReasons: value })}
              preview={preview}
            />
            {(model.targetMarketSelectionReasons?.includes(TargetMarketSelectionReasons.TierOtherReasons)
              || model.targetMarketSelectionReasons?.includes(TargetMarketSelectionReasons.RepBodyOtherReasons))
              && (
                <MultiLineField
                  ref={(r) => { this.specifyOtherTargetMarketSelectionReasons = r }}
                  id="specifyOtherTargetMarketSelectionReasons"
                  label={preview ? 'Other reasons, please specify' : ''}
                  value={model.specifyOtherTargetMarketSelectionReasons}
                  onChange={(value) => onChange({ specifyOtherTargetMarketSelectionReasons: value })}
                  maxLength={3000}
                  required={(model.targetMarketSelectionReasons?.includes(TargetMarketSelectionReasons.TierOtherReasons)
                    || model.targetMarketSelectionReasons?.includes(TargetMarketSelectionReasons.RepBodyOtherReasons))}
                  preview={preview}
                />
              )}

            <NumericCheckboxGroupField
              id="marketEntryPathways"
              ref={(r) => { this.marketEntryPathways = r }}
              label={(
                <span>
                  66. What is your
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/find-buyers-and-sales-partners/market-entry-strategies">market entry pathway?</a>
                  {' '}
                  (choose all that apply)
                </span>
            )}
              dataSource={marketEntryPathwayOptions}
              value={model.marketEntryPathways}
              onChange={(value) => onChange({ marketEntryPathways: value })}
              preview={preview}
            />
            {model.marketEntryPathways?.includes(MarketEntryPathways.Others)
              && (
                <MultiLineField
                  ref={(r) => { this.specifyOtherMarketEntryPathways = r }}
                  id="specifyOtherMarketEntryPathways"
                  label={preview ? 'Other, please specify' : ''}
                  value={model.specifyOtherMarketEntryPathways}
                  onChange={(value) => onChange({ specifyOtherMarketEntryPathways: value })}
                  maxLength={3000}
                  required={model.marketEntryPathways?.includes(MarketEntryPathways.Others)}
                  preview={preview}
                />
              )}

            {!model.isPeakIndustryBody && (
            <MultiLineField
              ref={(r) => { this.describeHowCompeteInTargetExportMarkets = r }}
              id="describeHowCompeteInTargetExportMarkets"
              label={(
                <span>
                  67. How will you
                  {' '}
                  <a target="blank" href="https://export.business.gov.au/find-export-markets/competitor-analysis">compete</a>
                  {' '}
                  in your target export markets?
                </span>
              )}
              value={model.describeHowCompeteInTargetExportMarkets}
              onChange={(value) => onChange({ describeHowCompeteInTargetExportMarkets: value })}
              maxLength={3000}
              preview={preview}
            />
            )}
          </EMDGAccordion>
        </div>

        <NextBackButtons
          onBack={() => history.push(`/reform/${model.applicationID}/eligibletiers`)}
          onNext={this.next}
          preview={preview}
        />

        {/* tierValidation on SaveNext; user-story #143098 */}
        {tierErrorMessage
            && (
            <Alert className="emdg-page-alerts emdg-page-alerts--error">
              <div dangerouslySetInnerHTML={{ __html: tierErrorMessage }} />
            </Alert>
            )}
        <Backdrop on={loading} />
      </>
    )
  }
}
